import * as React from "react";

import { Subheader } from "./SubHeader.styles";
import { SubHeaderColors, SubHeaderLevels } from "./SubHeaderTypes";

interface SubHeaderProps {
    level: SubHeaderLevels;
    color: SubHeaderColors;
    children: React.ReactNode;
}

export function SubHeader(props: SubHeaderProps): JSX.Element {
    return (
        <Subheader level={props.level} color={props.color}>
            {props.children}
        </Subheader>
    );
}
